var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { getGalaxyContainer, initTopMenu } from './Galaxy.functions';
import './Galaxy.scss';
var Galaxy = /** @class */ (function (_super) {
    __extends(Galaxy, _super);
    function Galaxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Component initialization
     */
    Galaxy.prototype.componentDidMount = function () {
        initTopMenu(getGalaxyContainer());
    };
    Galaxy.prototype.render = function () {
        var _a = this.props, galaxyMenu = _a.galaxyMenu, service = _a.service;
        return (React.createElement("div", { id: "galaxy" },
            React.createElement("div", { id: "galaxy-container", className: "glxy-container" },
                React.createElement("a", { href: "http://www.digischool.fr" }, "digischool"),
                React.createElement("nav", null,
                    React.createElement("ul", null, galaxyMenu
                        .filter(function (site) { return site.slug !== service; })
                        .map(function (site) { return (React.createElement("li", { key: "nav-" + site.title + "}" },
                        React.createElement("a", { href: site.url, target: "_blank", rel: "noopener" }, site.title))); }))),
                React.createElement("div", { id: "galaxy-btn-group" },
                    React.createElement("button", { id: "btn-previous", "aria-label": "D\u00E9filer les liens sur la gauche" },
                        React.createElement("i", null)),
                    React.createElement("button", { id: "btn-next", "aria-label": "D\u00E9filer les liens sur la droite" },
                        React.createElement("i", null))))));
    };
    return Galaxy;
}(React.Component));
export default Galaxy;
//# sourceMappingURL=Galaxy.js.map